import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import Chip from '@material-ui/core/Chip';
import Fab from '@material-ui/core/Fab';
import IconButton from '@material-ui/core/IconButton';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Skeleton from '@material-ui/lab/Skeleton';
import Icon from '@material-ui/core/Icon';

import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';

import * as math from '_core/utils/math';
import * as api from '_core/utils/api';
import { getVisitorPhotoSrc } from '_core/utils/getVisitorPhotoSrc';
import { Flex } from '_core/components/Flex';
import { ModalOuter } from '_core/components/ModalOuter';
import { ModalInner } from '_core/components/ModalInner';

import Row from './Row';

import { DefaultValue as ColumnValueDefault } from './value/Default';
import { FullnameValue as ColumnValueFullname } from './value/Fullname';
import { LocalityValue as ColumnValueLocality } from './value/Locality';
import { LoginValue as ColumnValueLogin } from './value/Login';
import { PhoneValue as ColumnValuePhone } from './value/Phone';
import { ObjectValue as ColumnValueObject } from './value/Object';
import { StatusValue as ColumnValueStatus, getStatusData } from './value/Status';


export default React.memo((props) => {
  const {
    l,
    classes,
    
    token,
    detailsColumns,
    rowInfo,
    setRowInfo
  } = props;
  
  
  const [statuses, setStatuses] = React.useState([]);
  
  React.useEffect(() => {
    getStatusData()
      .then((data) => setStatuses(data))
      .catch((error) => console.error(error))
  }, []);
  
  
  const renderModal = () => rowInfo && (
    <Flex gap={1} flexDirection="column">
      <Flex gap={1}>
        <Avatar src={rowInfo.photo && getVisitorPhotoSrc(rowInfo.photo, 'md')} className={classes.modalAvatar} />
        
        <Flex gap={1} flexDirection="column"  className={classes.modalUserInfo}>
          <Flex gap={1} justifyContent="space-between" className={classes.modalUserInfoLogin}>
            <Typography variant="h6"><ColumnValueLogin {...props} column={{ nameSplit: [['login']] }} data={rowInfo} /></Typography>
            <ColumnValueStatus {...props} column={{ nameSplit: [['status', 'status'], 'status'], valueData: statuses }} data={rowInfo} />
          </Flex>
          
          <Flex flexDirection="column">
            <Typography variant="h6"><ColumnValueFullname {...props} column={{ nameSplit: [['fullname']] }} data={rowInfo} /></Typography>
            
            <Typography variant="caption"><ColumnValueLocality {...props} column={{ nameSplit: [['locality']] }} data={rowInfo} isFull /></Typography>
            
            <Flex justifyContent="space-between">
              <Typography variant="caption"><ColumnValuePhone {...props} column={{ nameSplit: [['phone']] }} data={rowInfo} /></Typography>
              <Typography variant="caption"><ColumnValueDefault {...props} column={{ nameSplit: [['email']] }} data={rowInfo} /></Typography>
            </Flex>
          </Flex>
        </Flex>
      </Flex>
      
      {detailsColumns.map((column) => (
        <Flex flexDirection="column" className={classes.modalColumn}>
          <Typography variant="caption">{column.icon ? <Icon>{column.icon}</Icon> : null} {l(column.title)}</Typography>
          
          <column.ValueComponent {...props} column={column} data={rowInfo} />
        </Flex>
      ))}
    </Flex>
  );
  
  
  return (
    <ModalOuter
      open={!!rowInfo}
      maxWidth="sm"
      closeIcon={true}
      onClose={() => setRowInfo(null)}
    >
      <ModalInner content={renderModal()} />
    </ModalOuter>
  );
});
